import React from 'react';
import './LoadingSpinner.css';

const LoadingSpinner = ({ message = 'Loading...', type = 'page' }) => {
  return (
    <div className={`loading-spinner-container loading-${type}`}>
      <div className="loading-spinner-wrapper">
        <svg className="loading-spinner-svg" viewBox="0 0 50 50">
          <circle
            className="loading-spinner-track"
            cx="25"
            cy="25"
            r="20"
            fill="none"
            strokeWidth="4"
          />
          <circle
            className="loading-spinner-path"
            cx="25"
            cy="25"
            r="20"
            fill="none"
            strokeWidth="4"
          />
        </svg>
        {type !== 'inline' && message && (
          <p className="loading-spinner-message">{message}</p>
        )}
      </div>
    </div>
  );
};

export default LoadingSpinner;
